import { render, staticRenderFns } from "./BonusRecordCommander.vue?vue&type=template&id=bc325344&scoped=true"
import script from "./BonusRecordCommander.vue?vue&type=script&lang=js"
export * from "./BonusRecordCommander.vue?vue&type=script&lang=js"
import style0 from "./BonusRecordCommander.vue?vue&type=style&index=0&id=bc325344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc325344",
  null
  
)

export default component.exports